import React from 'react';
import classes from './BuildControl.css';

// Individual build control object to be filled in with ingredient info
const buildControl = (props)=>
(
    <div className = {classes.BuildControl}>
        <div
            className = {classes.Label}>{props.label}</div> 
        <button
            className = {classes.More}
            onClick = {props.added}>Add</button>
        <button 
            className = {classes.Less}
            onClick = {props.removed}
            disabled = {props.disabled}> Remove</button> 
        
    </div>
);
//  ^^ "disabled" is a default property you can set on an HTML element 
export default buildControl;


// WEBPACK FOOTER //
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.js